import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TableExt, TableInfo, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { getTableParams } from './grid.params';
import { ActionInfo } from './blocks/action-info';

export const ActionGrid = (props) => {
  const { count, entries, className, theme, getXlsAction } = props;
  const [row, setRow] = useState();
  const { t } = useTranslation();

  // actions
  const actions = [];

  /**
   * showinfo
   * @param {*} row
   */
  const showInfo = (row) => {
    setRow(row);
  };

  /**
   * close info
   */
  const closeInfo = () => {
    setRow(null);
  };

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), [t]);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('action', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });
  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('grid.Серый список')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={props.clientId}
        onRowClick={showInfo}
        {...restTableParams}
        fields={fields}
      />

      {row && <ActionInfo close={closeInfo} row={row} />}
    </GridBox>
  );
};
